import {AxiosResponse} from 'axios'
import {ListFavoritesRequest, Favorite} from './types'
import {HttpInstance} from '../createHttpInstance'

export interface ListFavorites<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const listFavorites: ListFavorites<ListFavoritesRequest, Favorite> = (
  http,
  params,
) => {
  const {ClientID, PageNumber, PageSize, PersonID} = params

  const path = '/v1/photos/favorites/{personid}'.replace(
    '{personid}',
    PersonID.toString(),
  )

  return http.request<Favorite>({
    method: 'GET',
    url: `${path}?clientid=${ClientID}&pagenumber=${PageNumber}&pagesize=${PageSize}`,
  })
}
